<template>
  <div class="distributed">
    <div class="distributed-header">
      <div class="distributed-logo"></div>
      <span class="school">学区分布</span>
      <span class="word">School district distribution</span>
      <div class="header-bottom"></div>
    </div>
    <div class="distributedCenter">
      <div class="distributed-center">
        <div
          :class="disActive == 1 ? 'distributed-bg active' : 'distributed-bg'"
          @click="disnav(1)"
        >
          <div class="btn school-n">北校区</div>
        </div>
        <div
          :class="disActive == 2 ? 'distributed-bg active' : 'distributed-bg'"
          @click="disnav(2)"
        >
          <div class="btn school-s">南校区</div>
        </div>
      </div>
    </div>
    <div class="distributed-list">
      <div class="list-box" v-show="disActive == 1">
        <div
          :class="northNum == index ? 'list-active' : ''"
          v-for="(item, index) in northCampus"
          :key="index"
          @click="northActive(index)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="list-box" v-show="disActive == 2">
        <div
          :class="southNum == index ? 'list-active' : ''"
          v-for="(item, index) in southCampus"
          :key="index"
          @click="southActive(index)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      disActive: 2,
      southCampus: [
        {
          title: "研发大楼",
        },
        {
          title: "桃园餐厅",
        },
        {
          title: "材料中心",
        },
        {
          title: "机器人实训中心",
        },
        {
          title: "第六教学楼",
        },
        {
          title: "旌湖尚品酒店",
        },
        {
          title: "孵化大楼",
        },
      ],
      northCampus: [
        {
          title: "第五教学楼",
        },
        {
          title: "第三教学楼",
        },
        {
          title: "建筑实训中心",
        },
        {
          title: "工程中心",
        },
        {
          title: "德阳图书馆",
        },
        {
          title: "第一教学楼",
        },
      ],
      northNum: -1,
      southNum: -1,
    };
  },
  mounted() {
    window.activeClear = this.activeClear;
  },
  methods: {
    disnav(num) {
      this.disActive = num;
    },
    southActive(num) {
      this.$emit("viewUncheck");
      this.southNum = num;
      if (num == 0) {
        document.getElementById("iframe").contentWindow.MMAPI.focus(8);
      } else if (num == 1) {
        document.getElementById("iframe").contentWindow.MMAPI.focus(9);
      } else if (num == 2) {
        document.getElementById("iframe").contentWindow.MMAPI.focus(2);
      } else if (num == 3) {
        document.getElementById("iframe").contentWindow.MMAPI.focus(7);
      } else if (num == 4) {
        document.getElementById("iframe").contentWindow.MMAPI.focus(5);
      } else if (num == 5) {
        document.getElementById("iframe").contentWindow.MMAPI.focus(1);
      } else if (num == 6) {
        document.getElementById("iframe").contentWindow.MMAPI.focus(6);
      }
    },
    northActive(num) {
      this.$emit("viewUncheck");
      if (num < 2) {
        this.northNum = num;
        if (num == 0) {
          document.getElementById("iframe").contentWindow.MMAPI.focus(4);
        } else if (num == 1) {
          document.getElementById("iframe").contentWindow.MMAPI.focus(3);
        }
      }
    },
    activeClear() {
      this.northNum = -1;
      this.southNum = -1;
    },
  },
};
</script>
<style scoped>
.distributed {
  width: 100%;
  height: 100%;
  background: url("./../../../assets/img/distributed-bg.png") no-repeat;
  background-size: 100% 100%;
  z-index: 999;
  overflow: hidden;
}
.distributed-header {
  width: 100%;
  height: 12%;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.05rem;
  display: flex;
}
.header-bottom {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 1px;
  background: url("./../../../assets/img/distributed-line.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .distributed-logo {
  margin-top: 1%;
  width: 0.6375rem;
  background: url("./../../../assets/img/distributed-logo.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .school {
  font-size: 0.225rem;
  font-family: "pmzd";
  display: flex;
  align-items: center;
  margin: 0 0.0625rem;
  background-image: -webkit-linear-gradient(bottom, #7db2ff, #ffffff);
  -webkit-background-clip: text;
  color: transparent;
}
.distributed-header .word {
  font-family: "SourceHanSansCN";
  color: #9cc3ff;
  font-size: 0.15rem;
  margin-top: 2%;
}
.distributedCenter {
  width: 100%;
  height: 15%;
  padding: 0 0.125rem;
  box-sizing: border-box;
  margin-top: 2%;
}
.distributedCenter .distributed-center {
  width: 100%;
  height: 100%;
  background: url("./../../../assets/img/distributed-center.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.distributedCenter .distributed-center .btn {
  width: 1.25rem;
  height: 100%;
  background: url("./../../../assets/img/btn-bg.png") no-repeat center center;
  background-size: 100%;
  text-align: center;
  font-family: "SourceHanSansCN";
  font-size: 0.175rem;
  color: #c5dffd;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
}
.distributed-list {
  padding: 0 0.1125rem;
  margin-top: 2%;
  box-sizing: border-box;
  height: 61%;
}
.distributed-list .list-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  font-size: 0.175rem;
  font-family: "SourceHanSansCN";
  color: #deedff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  letter-spacing: 0.05rem;
}
.distributed-list .list-box::-webkit-scrollbar {
  width: 3px;
  display: none;
}
.distributed-list .list-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.6);
}
.distributed-list ul::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
/* .distributed-list .list-box li {
  display: flex;
  height: 0.325rem;
  font-size: 0.175rem;
  font-family: "pmzd";
  color: #deedff;
  margin-bottom: 0.2125rem;
} */
.distributed-list .list-box div {
  width: 1.7125rem;
  height: 22%;
  background: url("./../../../assets/img/list-bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 3%;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
}
.distributed-list .list-box div:nth-child(1) {
  margin-top: 0%;
}
.distributed-list .list-box div:nth-child(2) {
  margin-top: 0%;
}
.distributed-list .list-box:nth-child(1) div:nth-child(3) {
  color: rgb(121, 117, 117);
}
.distributed-list .list-box:nth-child(1) div:nth-child(4) {
  color: rgb(121, 117, 117);
}
.distributed-list .list-box:nth-child(1) div:nth-child(5) {
  color: rgb(121, 117, 117);
}
.distributed-list .list-box:nth-child(1) div:nth-child(6) {
  color: rgb(121, 117, 117);
}

.distributed-list .list-box div:nth-child(odd) {
  position: relative;
}
.distributed-list .list-box div:nth-child(odd)::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;

  transform: translateY(-50%);
  right: -0.683333rem;
  width: 0.3625rem;
  height: 0.1625rem;
  background: url("./../../../assets/img/parting.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 0.125rem;
  z-index: 999;
}
/* .distributed-list ul li span {
  display: inline-block;
  width: 0.3625rem;
  height: 0.1625rem;
  background: url("./../../../assets/img/parting.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 0.125rem;
} */
.distributed-bg {
  width: 1.6rem;
  height: 0.2625rem;
  display: flex;
  justify-content: center;
}
.active {
  background: url("./../../../assets/img/active-bg.png") no-repeat;
  background-size: 100% 100%;
}
.distributedCenter .distributed-center .active .btn {
  background: url("./../../../assets/img/active-arrow.png") no-repeat center
    center;
  color: #d4c8b4;
  background-size: 100%;
}
.list-active {
  background: url("./../../../assets/img/active-list-bg.png") no-repeat !important;
  background-size: 100% 100%;
}
</style>